import { render } from "./OrganizationList.vue?vue&type=template&id=7ce0d201"
import script from "./OrganizationList.vue?vue&type=script&lang=js"
export * from "./OrganizationList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__